"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const faqData = [{
    id: 1,
    question: "What is cloud accounting?",
    answer: "Cloud accounting uses online software to manage your financial data securely from anywhere. It provides real-time insights, automatic backups, and seamless collaboration with your accountant."
  }, {
    id: 2,
    question: "Is my financial data secure in the cloud?",
    answer: "Yes, cloud accounting platforms use bank-level encryption, multi-factor authentication, and regular security audits to protect your data. Your information is often more secure in the cloud than on local computers."
  }, {
    id: 3,
    question: "Can I access my accounts from any device?",
    answer: "Absolutely. Cloud accounting software works on desktop computers, laptops, tablets, and smartphones, giving you flexibility to manage your finances wherever you are."
  }, {
    id: 4,
    question: "How much does cloud accounting cost?",
    answer: "Pricing varies based on your business size and needs. Sloane offers flexible packages starting from basic bookkeeping to comprehensive financial management solutions. Contact us for a personalized quote."
  }, {
    id: 5,
    question: "Will I need to install any software?",
    answer: "No installation is required. Cloud accounting runs entirely through your web browser, which means you always have access to the latest features without manual updates."
  }, {
    id: 6,
    question: "What if I need help setting up or using the platform?",
    answer: "Sloane provides full onboarding support, training sessions, and ongoing assistance. Our team is here to ensure you get the most out of your cloud accounting solution."
  }];
  return <section id="frequently-asked-questions" ref={ref} className={`w-full py-24 md:py-32 bg-[hsl(0,0%,16%)] transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="text-[36px] md:text-[48px] leading-[1.2] font-bold tracking-[-0.2px] text-white mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-[16px] md:text-[18px] leading-[1.6] text-white/80 max-w-2xl mx-auto">
            Find answers to common questions about Sloane's cloud accounting
            services and how we can help your business thrive.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {faqData.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-[var(--radius-sm)] px-6 hover:bg-white/8 transition-colors duration-[var(--duration-fast)]">
                <AccordionTrigger className="text-white text-left text-[16px] md:text-[18px] font-semibold hover:text-primary [&[data-state=open]>svg]:text-primary focus-visible:ring-primary/30">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 text-[15px] md:text-[16px] leading-[1.6]">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}